module.exports = __webpack_public_path__ + "img/map.c7a7917a.svg";